import { ISimilarOffersData } from '../store/map_similar';
import { IMakeRequest } from '../utils/make_request';
import { filterServerResponse } from './helpers';
import { mergeBaseUri } from '@cian/http-api/shared';

export function fetchSimilarObjects(
  makeRequest: IMakeRequest,
  apiBaseUrl: string,
  bounds: [[number, number], [number, number]],
  similarQS: string,
  subdomain: string,
) {
  return makeRequest({
    method: 'GET',
    uri: mergeBaseUri(apiBaseUrl.replace('www', subdomain), {
      path: '/ajax/map/roundabout/',
      // tslint:disable-next-line:max-line-length
      query: `${similarQS}&in_polygon[0]=${getFormattedBoundsQuery(bounds)}`,
    }),
  })
    .then(filterServerResponse)
    .then(response => {
      let data: ISimilarOffersData;

      try {
        data = JSON.parse(response.responseBody);
      } catch (error) {
        throw new Error();
      }

      return data;
    });
}

function getFormattedBoundsQuery(bounds: [[number, number], [number, number]]) {
  const offset = 1;

  // tslint:disable-next-line:max-line-length
  return `${bounds[0][0 + offset].toFixed(6)}_${bounds[0][1 - offset].toFixed(6)},${bounds[0][0 + offset].toFixed(
    6,
  )}_${bounds[1][1 - offset].toFixed(6)},${bounds[1][0 + offset].toFixed(6)}_${bounds[1][1 - offset].toFixed(
    6,
  )},${bounds[1][0 + offset].toFixed(6)}_${bounds[0][1 - offset].toFixed(6)}`;
}
